import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=46691c3e&scoped=true"
import script from "./ProductGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductGallery.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&id=46691c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46691c3e",
  null
  
)

export default component.exports